import { render, staticRenderFns } from "./orderProcessAuditAction.vue?vue&type=template&id=2b204804&scoped=true"
import script from "./orderProcessAuditAction.vue?vue&type=script&lang=js"
export * from "./orderProcessAuditAction.vue?vue&type=script&lang=js"
import style0 from "./orderProcessAuditAction.vue?vue&type=style&index=0&id=2b204804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b204804",
  null
  
)

export default component.exports